import t from "./_getMapData.js";
var r = t;
function p(e) {
  var a = r(this, e).delete(e);
  return this.size -= a ? 1 : 0, a;
}
var l = p;
export {
  l as default
};
//# sourceMappingURL=_mapCacheDelete.js.map
